import React from 'react'
import { KanbanBoard } from '../components/KanbanBoard'

export const Kanban = () => {
  return <KanbanBoard />
}
